import { Button, Menu, MenuItem } from "@mui/material";
import React, { useEffect } from "react";
import DateIcon from "../styles/svg/date-picker.svg";
import DateRange from "./DateRange";
// import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";

function SelectDatePicker() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMobile = useMediaQuery({ maxWidth: "960px" });
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedDate = searchParams.get("date");
  const open = Boolean(anchorEl);
  const date = JSON.parse("{}");

  useEffect(() => {
    if (date) {
      const obj = {
        startDate: new Date(date.startDate),
        endDate: new Date(date.endDate),
        key: "selection",
      };
      //   dispatch(setDateRange(obj));
    }
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const heading = selectedDate
    ? `${moment(JSON.parse(selectedDate).startDate).format(
        "MM/DD/YYYY"
      )} - ${moment(JSON.parse(selectedDate).endDate).format("MM/DD/YYYY")}`
    : "Date Range";
  // const heading = "Date Range";
  return (
    <div >
      {isMobile ? (
        <img
          src={DateIcon}
          onClick={(event) => setAnchorEl(event.currentTarget)}
          className="ml-1"
        />
      ) : (
        <Button
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-haspopup="true"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          endIcon={<img src={DateIcon} />}
          // className="white-button epics-btn"
          className="filter-btn white-button ml-4 justify-content-space-between"
          sx={{
            height: "36px",
            width: "224px",
            border: "1px solid #919EAB33",
            color: "#16304F99",
            textTransform: "capitalize",
            fontFamily: "Segoe UI Regular",
            fontSize: "14px",
            borderRadius: "4px",
            justifyContent: "space-between",
            "&:hover": {
              outline: "none",
              // backgroundColor: "rgb(240 249 254)",
              border: " 1px solid #919EAB33",
              color: "#16304F99",
            },
          }}
        >
          {/* <img src={apicIcon} className="header-filter-icon" alt="not found" />{" "} */}
          <p className="header-action-button-text mr-1">{heading}</p>
        </Button>
      )}
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "epics-board-dropdown",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 14,
              height: 14,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem onClick={() => setAnchorEl(null)}>Epics 1</MenuItem>
        <MenuItem onClick={() => setAnchorEl(null)}>Epics 2</MenuItem> */}
        <DateRange onClose={() => setAnchorEl(null)} />
      </Menu>
    </div>
  );
}
export default SelectDatePicker;
